<div class="auth">
  @switch (wizardStepsService.activeStep|async) {
    @case (1) {
      <app-forget-password-step-1></app-forget-password-step-1>
    }
    @case (2) {
      <app-forget-password-step-2></app-forget-password-step-2>
    }
    @case (3) {
      <app-forget-password-step-3></app-forget-password-step-3>
    }
  }
</div>
